import React from "react";

export default function RecordNotFound() {
  return (
    <div className="alert alert-danger text-center fw-bold" role="alert">
      Lo sentimos, Registro no encontrado.
    </div>
  );
}
